import { TEXT_PLACEHOLDER, BORDER_DASHED } from "../tokens";
import { EditablePath, useEditable } from "../editable/EditableContext";

// Controls for the lists inside an element: the rows of a table, the items of a
// checklist. They render nothing at all unless the host registered an
// `onListChange` and passed a path down, so the client report is untouched —
// same contract as `Ed`.
//
// A one-item list keeps its remove control hidden on purpose: a blank new row is
// built by copying an existing one, so emptying a list would leave the editor
// with no shape to clone and no way back.

const buttonStyle = {
  border: "1px solid rgba(239,68,68,0.3)",
  background: "rgba(239,68,68,0.05)",
  color: "#ef4444",
  borderRadius: 4,
  cursor: "pointer",
  fontSize: 10,
  lineHeight: 1.4,
  padding: "0 5px",
} as const;

const addStyle = {
  border: `1px dashed ${BORDER_DASHED}`,
  background: "transparent",
  color: TEXT_PLACEHOLDER,
  borderRadius: 4,
  cursor: "pointer",
  fontSize: 11,
  padding: "2px 8px",
  marginTop: 4,
} as const;

/** Removes the item at `index` from the list at `path`. */
export const RemoveItem = ({ path, index, count, title = "Eliminar fila" }: {
  path?: EditablePath;
  index: number;
  count: number;
  title?: string;
}) => {
  const { editable, onListChange } = useEditable();
  if (!path || !editable || !onListChange || count < 2) return null;
  return (
    <button type="button" title={title} style={buttonStyle}
      onClick={() => onListChange(path, "remove", index)}>×</button>
  );
};

/** Appends a blank copy of the last item of the list at `path`. */
export const AddItem = ({ path, count, label = "+ fila" }: {
  path?: EditablePath;
  count: number;
  label?: string;
}) => {
  const { editable, onListChange } = useEditable();
  if (!path || !editable || !onListChange || count < 1) return null;
  return (
    <button type="button" style={addStyle}
      onClick={() => onListChange(path, "add", count - 1)}>{label}</button>
  );
};
